import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import { useEntity } from '@backstage/plugin-catalog-react';

export const BucketIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 550.9 550.9">
        <path d="M275.15,133.5L275.15,133.5c-102.2,0-185.4,28.8-185.4,63.6l43.5,304.8c0,26.899,63.6,49,142,49c78.4,0,142-22,142-49   l42.8-304.8C460.55,161.7,377.351,133.5,275.15,133.5z M275.15,241.8c-53.9,0-102.2-8-136.5-20.8l42.2,299.9   c-6.7-1.801-12.9-4.301-18.4-6.7l-42.8-301.7c-6.1-3.1-11.6-6.7-15.9-10.4c28.2-22.6,94.2-39.2,170.7-39.2l0,0   c76.5,0,142.6,15.9,170.7,39.2C417.75,225.3,352.25,241.8,275.15,241.8z M469.15,169c-3.101-4.3-6.7-8.6-11-11.6   c-8-6.7-17.7-12.2-28.2-16.5c-19.6-63.1-77.7-108.4-147.5-108.4h-14c-69.8,0-127.9,45.3-147.5,108.3l0,0   c-11,4.9-20.2,9.8-28.2,16.5c-4.3,3.7-8,7.3-11,11.6C90.35,74,169.85,0,267.15,0h16.5C380.45,0.1,459.95,74.2,469.15,169z" />
    </SvgIcon>
);

export const Ec2Icon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="-27 0 310 310">
        <g>
            <path d="M42.754,244.495 L12.836,251.321 L12.836,57.565 L42.754,64.404 L42.754,244.495" fill="#F68536" />
            <path d="M80.082,255.931 L42.754,266.539 L42.754,42.612 L80.082,53.207 L80.082,255.931" fill="#F68536" />
            <path d="M127.966,267.681 L80.082,285.205 L80.082,23.946 L127.966,41.462 L127.966,267.681" fill="#F68536" />
            <path d="M256,245.079 L127.966,309.096 L127.966,0 L256,64.017 L256,245.079" fill="#F68536" />
            <path d="M102.444,12.763 L127.966,0 L127.966,309.096 L102.444,296.337 L102.444,12.763" fill="#9D5025" />
            <path d="M60.325,33.82 L80.082,23.942 L80.082,285.154 L60.325,275.276 L60.325,33.82" fill="#9D5025" />
            <path d="M27.016,50.477 L42.754,42.608 L42.754,266.488 L27.016,258.614 L27.016,50.477" fill="#9D5025" />
            <path d="M12.836,57.565 L0,63.983 L0,245.117 L12.836,251.531 L12.836,57.565" fill="#9D5025" />
        </g>
    </SvgIcon>
);

export const DropletIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M12 2C12 2 4 10.5 4 15a8 8 0 0 0 16 0C20 10.5 12 2 12 2zm0 18a6 6 0 0 1-6-6c0-3.15 4.17-8.82 6-11.15C13.83 5.18 18 10.85 18 14a6 6 0 0 1-6 6z" />
        <path d="M12 19a5 5 0 0 0 5-5c0-.55-.45-1-1-1s-1 .45-1 1a3 3 0 0 1-3 3c-.55 0-1 .45-1 1s.45 1 1 1z" />
    </SvgIcon>
);

export const SmartResourceIcon = (props: SvgIconProps) => {
    let entity;
    try {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const context = useEntity();
        entity = context.entity;
    } catch (e) {
        // No context, return default decoration
    }

    if (entity?.spec?.type === 's3-bucket') {
        return <BucketIcon {...props} />;
    }
    if (entity?.spec?.type === 'ec2-instance') {
        return <Ec2Icon {...props} />;
    }
    if (entity?.spec?.type === 'digitalocean-droplet') {
        return <DropletIcon {...props} />;
    }

    return <AccountTreeIcon {...props} />;
};
